
<div class="contentWrapper">
    <div class="logo">
        <div class="Wrapper">
            <!-- <span>flowtrics</span> -->
            <a [routerLink]="'/'"><img src="../../../assets/images/logo/flowtrics_logo.png" alt=""></a>
        </div> 
    </div>   
    <div class="Wrapper">
        <h3 *ngIf="this.isCancel==false">Thanks for filling form!</h3>
        <h3 *ngIf="this.isCancel==true">Operation has been cancelled.</h3>
        <div class="emailImg">
            <img src="../../../assets/images/thanksEmail.png" alt="">
        </div>
        <a class="register" href="http://flowtrics.com/"  mat-stroked-button color="primary"  type="button">Get Started</a>
    </div> 
</div>


